import { getNumberFormat } from './getNumberFormat'

/**
 * Options are module-level constants, not literals built per call, so
 * getNumberFormat() resolves them on its identity path — see the header there
 * for why that matters (a fresh `Intl.NumberFormat` costs ~13.8µs, and this
 * runs once per rendered currency cell).
 */
const CURRENCY_OPTIONS: Intl.NumberFormatOptions = {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  trailingZeroDisplay: 'stripIfInteger',
}

/** Same, plus compact notation ($1K) — used for exact multiples of 100. */
const COMPACT_CURRENCY_OPTIONS: Intl.NumberFormatOptions = {
  ...CURRENCY_OPTIONS,
  notation: 'compact',
}

export function formatCurrencyAmount(amount: number) {
  const options =
    amount % 100 === 0 ? COMPACT_CURRENCY_OPTIONS : CURRENCY_OPTIONS

  return getNumberFormat('en-US', options).format(amount)
}

export function formatDollars(amount: number | undefined | null) {
  if (amount === undefined || (typeof amount === 'string' && amount === '')) {
    return '--'
  }
  if (amount === null) {
    return '--' // ''
  }
  if (amount === 0) {
    return '--'
  }
  return formatCurrencyAmount(amount)
}
